module.exports = __webpack_public_path__ + "static/media/array_of_strings.a2f824bc.png";